/**
 * HelpPage — FAQ and support. Static content, so this is fully real today.
 */

import { Container, PageHeader } from '@/components/layout/Container';
import { Card } from '@/components/ui';

const FAQS = [
  {
    q: 'How fast is delivery?',
    a: 'Most orders reach your hostel within 10–15 minutes, since everything ships from the on-campus store.',
  },
  {
    q: 'Which areas do you cover?',
    a: 'Currently the entire campus — all hostels, blocks and academic buildings. More colleges are coming soon.',
  },
  {
    q: 'How do I pay?',
    a: 'Online payment is being added. In the current version, checkout is being set up and cash on delivery will be available at launch.',
  },
  {
    q: 'Can I track my order?',
    a: 'Live order tracking is on the roadmap. For now you will see status updates on your Orders page.',
  },
];

export function HelpPage() {
  return (
    <Container className="max-w-3xl">
      <PageHeader title="Help & Support" subtitle="Answers to common questions" />
      <div className="space-y-3 pb-6">
        {FAQS.map((faq) => (
          <Card key={faq.q} className="p-5">
            <h3 className="text-sm font-semibold text-ink">{faq.q}</h3>
            <p className="mt-1.5 text-sm text-muted">{faq.a}</p>
          </Card>
        ))}
      </div>
    </Container>
  );
}

export default HelpPage;
